module.exports = __webpack_public_path__ + "static/terry-dickens-85e4cf6a241b015a4aaf07f0be9e0a1d.jpg";